<svg
    width="279"
    height="200"
    viewBox="0 0 279 200"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>
    <g app-helipad />
</svg>
